import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
function MobileNoticeBoardDetails() {
    const navigate = useNavigate();
  return (
    <>
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/NoticeBoard")}
        />
        <h1>Notice Board Details</h1>
    </div>
    <div className='topSpace'></div>
    <div className="wraperMobile">
    <div className="NoticeBoardTile NoticeBoardTileDetails">
       <p className='invoiceNo'>Notice No: 101</p>
       <p className='NoticeBoardTitle'>Notice Board Title</p>
       <p className='NoticeBoardTime'>22/04/2023</p>
       <p className='NoticeBoardDescription'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
       <p className='AttchmentTxt'>Attachments</p>
       <p className='AttchmentFileName'>File Name</p>
    </div>
    </div>    
    </>
  )
}

export default MobileNoticeBoardDetails